import request from '../http'

/**
 * 分页查询系列书名映射
 * @param {Object} params - { keyword, adAccountId, pageNo, pageSize }
 */
export function listCampaignBooks(params) {
  return request({ url: '/dev/campaign-books', method: 'get', params })
}
